/********************************************************************
Alexander Self
Image Map
10/24/17
- Clickable and interactive image map
********************************************************************/
import React from 'react';
import MapModal from './dashboard_map_modal';


const GeneralMap = ({onclick, onmouseover, _map, fields, mapId, id, selectedField, fieldHours,
  lastVisited, harvest, work}) => {
  return (
    <div>
      {
        fields.map((f) => (
          <MapModal key={f.coords} field={f} selectedField={selectedField} fieldHours={fieldHours} lastVisited={lastVisited}
          harvest={harvest} work={work}
          />
        ))
      }
      <img src={_map} useMap={`#${mapId}`} id={id} alt="Map" />
      <map name={mapId}>
        {
          fields.map((f) => (
            <a key={f.id} className="modal-trigger" href={`#${f.id}`}>
              <area shape={f.shape} coords={f.coords} alt={f.alt} id={f.id}
                onClick={(e) => onclick(e.target.id)} onMouseOver={(e) => onmouseover(e.target.id)}
              />
            </a>
          ))
        }
      </map>
    </div>
  )
}

export default GeneralMap;

























/* END */



// WEBPACK FOOTER //
// ./src/components/dashboard/GeneralMap.js